import { Button, PageHeader, Table } from "@/components";
import {
  BREAK_TIME_HEADER_KEY,
  BREAK_TIME_KEY,
  CONTINUOUS_WORKING_TIME_HEADER_KEY,
  CONTINUOUS_WORKING_TIME_KEY,
  createEditWorkScheduleFlexible,
  DATE_FORMAT_HM,
  DAY_KEY,
  END_TIME_HEADER_KEY,
  END_TIME_KEY,
  formatStringToDate,
  MINIMUM_WORKING_TIME_KEY,
  ROUTER_PAGE_POLICY_CONFIG,
  ROUTER_PAGE_POLICY_CONFIG_CREATE,
  ROUTER_PAGE_POLICY_CONFIG_EDIT,
  START_TIME_HEADER_KEY,
  START_TIME_KEY,
  WORKING_DAY_KEY,
  WORKING_TIME_HEADER_KEY,
  WORKING_TIME_KEY,
} from "@/utils";
import moment from "moment";
import EditableCell from "./EditableCell.vue";

const scopedSlots = [
  {
    type: "checkbox",
    slot: WORKING_DAY_KEY,
  },
  {
    type: "time-picker",
    slot: START_TIME_KEY,
  },
  {
    type: "time-picker",
    slot: END_TIME_KEY,
  },
  {
    type: "input",
    slot: WORKING_TIME_KEY,
  },
  {
    type: "input",
    slot: MINIMUM_WORKING_TIME_KEY,
  },
  {
    type: "input",
    slot: CONTINUOUS_WORKING_TIME_KEY,
  },
  {
    type: "input",
    slot: BREAK_TIME_KEY,
  },
];

const slots = [
  {
    slot: START_TIME_HEADER_KEY,
    title: "Start time",
    required: true,
  },
  {
    slot: END_TIME_HEADER_KEY,
    title: "End time",
    required: true,
  },
  {
    slot: WORKING_TIME_HEADER_KEY,
    title: "Working time",
    required: true,
  },
  {
    slot: CONTINUOUS_WORKING_TIME_HEADER_KEY,
    title: "Continuous working time",
    required: true,
  },
  {
    slot: BREAK_TIME_HEADER_KEY,
    title: "Break time",
    required: true,
  },
];

const dataSources = [
  {
    key: "monday",
    day: "Monday",
    workingDay: true,
    startTime: "07:30",
    endTime: "07:30",
    workingTime: "8.00 hours",
    minimumWorkingTime: "8.00 hours",
    continuousWorkingTime: "8.00 hours",
    breakTime: "8.00 hours",
  },
  {
    key: "tuesday",
    day: "Tuesday",
    workingDay: true,
    startTime: "07:30",
    endTime: "07:30",
    workingTime: "8.00 hours",
    minimumWorkingTime: "8.00 hours",
    continuousWorkingTime: "8.00 hours",
    breakTime: "8.00 hours",
  },
  {
    key: "wednesday",
    day: "Wednesday",
    workingDay: true,
    startTime: "07:30",
    endTime: "07:30",
    workingTime: "8.00 hours",
    minimumWorkingTime: "8.00 hours",
    continuousWorkingTime: "8.00 hours",
    breakTime: "8.00 hours",
  },
  {
    key: "thursday",
    day: "Thursday",
    workingDay: true,
    startTime: "07:30",
    endTime: "07:30",
    workingTime: "8.00 hours",
    minimumWorkingTime: "8.00 hours",
    continuousWorkingTime: "8.00 hours",
    breakTime: "8.00 hours",
  },
  {
    key: "friday",
    day: "Friday",
    workingDay: true,
    startTime: "07:30",
    endTime: "07:30",
    workingTime: "8.00 hours",
    minimumWorkingTime: "8.00 hours",
    continuousWorkingTime: "8.00 hours",
    breakTime: "8.00 hours",
  },
  {
    key: "saturday",
    day: "Saturday",
    workingDay: true,
    startTime: "07:30",
    endTime: "07:30",
    workingTime: "8.00 hours",
    minimumWorkingTime: "8.00 hours",
    continuousWorkingTime: "8.00 hours",
    breakTime: "8.00 hours",
  },
  {
    key: "sunday",
    day: "Sunday",
    workingDay: true,
    startTime: "07:30",
    endTime: "07:30",
    workingTime: "8.00 hours",
    minimumWorkingTime: "8.00 hours",
    continuousWorkingTime: "8.00 hours",
    breakTime: "8.00 hours",
  },
];

const MAX_LENGTH_200 = 200;

const initialRow = {
  startTime: "null",
  endTime: "null",
  workingTime: "--",
  minimumWorkingTime: "--",
  continuousWorkingTime: "--",
  breakTime: "--",
};

export default {
  name: "CreateEditWorkScheduleSetting",
  components: {
    PageHeader,
    Table,
    EditableCell: EditableCell,
    Button,
  },
  data() {
    return {
      formRQ: this.$form.createForm(this, {
        name: "formRQ",
      }),
      formItemLayout: {
        labelCol: { span: 3 },
        wrapperCol: { span: 18, offset: 1 },
      },
      columns: createEditWorkScheduleFlexible,
      data: dataSources,
      DATE_FORMAT_HM,
      DAY_KEY,
      WORKING_DAY_KEY,
      START_TIME_KEY,
      END_TIME_KEY,
      WORKING_TIME_KEY,
      MINIMUM_WORKING_TIME_KEY,
      CONTINUOUS_WORKING_TIME_KEY,
      BREAK_TIME_KEY,
      ROUTER_PAGE_POLICY_CONFIG_EDIT,
      MAX_LENGTH_200,
      scopedSlots,
      slots,
      scopedSlotsTable: scopedSlots.map(({ slot }) => slot),
      slotsTable: slots.map(({ slot }) => slot),
    };
  },
  computed: {
    formHeader() {
      return this.generateText("header");
    },
    textButton() {
      return this.generateText();
    },
  },
  methods: {
    formatStringToDate,
    generateText(type) {
      const { name } = this.$route;
      if (name === ROUTER_PAGE_POLICY_CONFIG_CREATE) {
        if (type === "header") {
          return "Create work schedule";
        } else {
          return "Create";
        }
      } else if (name === ROUTER_PAGE_POLICY_CONFIG_EDIT) {
        if (type === "header") {
          return "Edit work schedule";
        } else {
          return "Save";
        }
      }
    },
    onBack() {
      this.$router.push({ name: ROUTER_PAGE_POLICY_CONFIG });
    },

    onCellChange(key, dataIndex, value, index) {
      const dataCell = document.querySelector(`tr[data-row-key=${key}] div[data-type=${dataIndex}]`);
      if (dataCell && !value) {
        dataCell.classList.remove("has-error");
        dataCell.classList.add("has-error");
      } else if (dataCell && value) {
        dataCell.classList.remove("has-error");
      }
      const dataSources = JSON.parse(JSON.stringify(this.data));
      let findDataEdit = dataSources[index];
      if (findDataEdit) {
        switch (dataIndex) {
          case WORKING_DAY_KEY: {
            findDataEdit[dataIndex] = value;
            if (!value) {
              const { key, day, workingDay } = findDataEdit;
              dataSources[index] = { ...initialRow, key, day, workingDay };
              const dataCells = document.querySelectorAll(`tr[data-row-key=${key}] .editable-cell`);
              for (const cell of dataCells) {
                cell.classList.remove("has-error");
              }
            }
            break;
          }
          case WORKING_TIME_KEY:
          case MINIMUM_WORKING_TIME_KEY:
          case CONTINUOUS_WORKING_TIME_KEY:
          case BREAK_TIME_KEY: {
            findDataEdit[dataIndex] = value;
            break;
          }
          case START_TIME_KEY:
          case END_TIME_KEY: {
            findDataEdit[dataIndex] = moment(value).format(DATE_FORMAT_HM);

            break;
          }
          default:
            break;
        }
        this.data = dataSources;
      }
    },
  },
};
